<template>
    <div class="group">
        <div class="head">
            <div>好友拼团</div>
            <div><router-link to="">好友都在拼团></router-link></div>
        </div>
        <div class="product">
            <ul>
                <li v-for="(item,index) of datas" :key="index">
                    <router-link to="">
                    <div><img :src="item.pic" /></div>
                    <div><p>已拼{{item.count}}单</p></div>
                    </router-link>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            datas:[
                // {goods_sn:1,pic:require('../../../assets/product/p1.png'),count:250 },
                // {goods_sn:2,pic:require('../../../assets/product/p2.png'),count:250 },
                // {goods_sn:3,pic:require('../../../assets/product/p3.png'),count:250 },
                // {goods_sn:4,pic:require('../../../assets/product/p4.png'),count:250 },
                // {goods_sn:5,pic:require('../../../assets/product/p5.png'),count:250 },
                // {goods_sn:6,pic:require('../../../assets/product/p6.png'),count:250 },
                // {goods_sn:7,pic:require('../../../assets/product/p7.png'),count:250 },
                // {goods_sn:8,pic:require('../../../assets/product/p8.png'),count:250 },
            ]
        }
    }
}
</script>
<style lang="scss" scoped>
.group{
    font-size: 0.25rem;
    width:6.58rem;
    border-radius: 5px;
    padding: 0.2rem;
    margin:auto;
    margin-top: 0.3rem;
    box-shadow: 0px 0px 5px #cecece;
    background: white;
    a{ color: #000000;}
    .head{
    display: flex;
    justify-content: space-between;
    }
  .product{
    ul{
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        li{
            width: 1.44rem;
            margin: 0.1rem 0;
            text-align: center;
            img{
                width: 100%;
            }
            p{
                background: #F84C4C;
                color: white;
                border-radius:10px ;
                font-size: 0.16rem;
            }
        }
    }
    }
}
   
</style>